"use strict"

class Press {
    constructor() {
        this.filterDate = "";
        this.filterFiliale = "";
        this.filters = document.querySelectorAll('.release-filter-select select');
        this.breakpoint = 790;
        this.filterParentId = "press-header";
        this.filterParentIdMobile = "press-content";
    }

    init() {
        if (this.filters.length !== 0) {
            this.filters.forEach((filter) => filter.addEventListener('change', () => this.handleSelect(filter)));
            this.changeFiltersParent();
            window.addEventListener('resize', () => this.changeFiltersParent());
            this.fetchPressRelease();
        }
    }

    fetchPressRelease() {
        const xhttp = new XMLHttpRequest();

        this.releaseUrl = document.getElementById("presse").dataset.api_url;
        xhttp.open('GET', this.releaseUrl);
        xhttp.send(null);
        xhttp.onreadystatechange = (e) => {
            if (e.target.readyState === XMLHttpRequest.DONE) {
                if (e.target.status === 200) {
                    const releasesData = JSON.parse(e.target.responseText);
                    const releaseItemData = releasesData.data.items;
                    const dateFilter = releasesData.data.filters_date;
                    const entityFilter = releasesData.data.filters_entity;

                    if (releaseItemData) {
                        releaseItemData.forEach((data) => this.createPressRelease(data));
                        Object.keys(dateFilter).forEach((date) => this.createFilter('filter-date', date, dateFilter[date]));
                        Object.keys(entityFilter).forEach((entity) => this.createFilter('filter-filiale', entity, entityFilter[entity]));
                    }
                }
            }
        }
    }

    createPressRelease(data) {
        const placeholder = document.getElementById('release-placeholder');
        const release = placeholder.cloneNode(true);
        const releaseList = document.getElementById('release-list');

        release.id = '';
        release.classList.add('release');
        release.querySelector('h3.release-title').innerHTML = data.title;
        release.querySelector('p.release-date').innerHTML = data.date;
        release.querySelector('.release-download a').href = data.document.url;
        release.dataset.date = data.filter_date;
        release.dataset.filiale = data.filter_entity;
        releaseList.appendChild(release);
    }

    createFilter(id, key, value) {
        const option = document.createElement('option');
        const dateSelect = document.getElementById(id);

        option.value = key;
        option.innerHTML = value;

        dateSelect.appendChild(option);
    }

    handleSelect(select) {
        // Updates filters and displayed releases
        (select.id === 'filter-date') ? this.filterDate = select.value : this.filterFiliale = select.value;
        const releases = document.querySelectorAll('.release');
        
        releases.forEach((release) => this.toggleRelease(release));
    }

    // Get all the releases that satisfy the filter
    filterRelease(release, date, filiale) {
        const releaseFiliale = release.dataset.filiale.split(',');
        const filialeFilter = releaseFiliale.some((value) => value === filiale);

        return (date === '' && filiale === '') ||                                   // No filter
            (filiale === '' && date === release.dataset.date) ||                    // Only date filter
            (date === '' && filialeFilter) ||                                       // Only filiale filter    
            (date === release.dataset.date && filialeFilter)  // Both filter
    }

    toggleRelease(release) {
        release.style.display = (this.filterRelease(release, this.filterDate, this.filterFiliale)) ? 'block' : 'none';
    }

    changeFiltersParent() {
        const filterWrapper = document.getElementById('filters');
        const filterParent = filterWrapper.parentNode;

        if (window.innerWidth <= this.breakpoint) {
            // Mobile
            if (filterParent.id !== this.filterParentIdMobile) {
                const target = document.getElementById(this.filterParentIdMobile);
                target.insertBefore(filterWrapper, target.childNodes[0]);
            }
        } else {
            // Desktop
            if (filterParent.id !== this.filterParentId) {
                const target = document.getElementById(this.filterParentId);
                target.appendChild(filterWrapper);
            }
        }
    }
}

export default Press;


// WEBPACK FOOTER //
// ./src/scripts/components/Press.js